var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdPartyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3F444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1221_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9417 21.5452H25.8549V20.8399C25.8549 20.4844 25.574 20.1955 25.2284 20.1955H16.5361V19.0776H25.2284C26.1733 19.0776 26.9417 19.8679 26.9417 20.8399V21.5452Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8619 46H15.1447C13.4107 46 12 44.5491 12 42.7656V20.0311C12 19.8724 12.0114 19.7126 12.0342 19.5549C12.2597 17.9822 13.5971 16.7961 15.1447 16.7961H38.8619C40.2655 16.7961 41.5104 17.7659 41.8892 19.1542C41.9669 19.437 42.0066 19.7321 42.0066 20.0311V21.5452H40.9198V20.0311C40.9198 19.8355 40.8937 19.6421 40.8431 19.4577C40.5953 18.5483 39.7808 17.914 38.8619 17.914H15.1447C14.1318 17.914 13.2569 18.6897 13.1091 19.7181C13.0944 19.8215 13.0868 19.9272 13.0868 20.0311V42.7656C13.0868 43.9326 14.01 44.8822 15.1447 44.8822H38.8619C39.9965 44.8822 40.9198 43.9326 40.9198 42.7656V41.6455H42.0066V42.7656C42.0066 44.5491 40.5959 46 38.8619 46Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4225 23.6596H27.5674C26.623 23.6596 25.8546 22.8693 25.8546 21.8979V20.8399C25.8546 20.4844 25.5737 20.1955 25.2281 20.1955H12.543V19.0776H25.2281C26.1731 19.0776 26.9414 19.8679 26.9414 20.8399V21.8979C26.9414 22.2528 27.2224 22.5418 27.5674 22.5418H41.4225V23.6596Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3215 24.7825H12.6436V25.9003H41.3215V24.7825Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1715 23.6389C23.0324 23.6389 22.8932 23.5842 22.7873 23.4752C22.5748 23.2566 22.5748 22.9028 22.7873 22.6849L23.7149 21.7308C23.9273 21.5123 24.2713 21.5123 24.4832 21.7308C24.6952 21.9493 24.6957 22.3031 24.4832 22.5211L23.5556 23.4752C23.4497 23.5842 23.3106 23.6389 23.1715 23.6389Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0998 23.639C23.9607 23.639 23.8216 23.5842 23.7156 23.4752L22.7881 22.5211C22.5756 22.3026 22.5761 21.9488 22.7881 21.7308C23 21.5129 23.3445 21.5123 23.5564 21.7308L24.484 22.6849C24.6965 22.9034 24.6959 23.2572 24.484 23.4752C24.378 23.5842 24.2389 23.639 24.0998 23.639Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0136 23.1828H14.8422C14.5423 23.1828 14.2988 22.9324 14.2988 22.6239C14.2988 22.3153 14.5423 22.0649 14.8422 22.0649H21.0136C21.3136 22.0649 21.557 22.3153 21.557 22.6239C21.557 22.9324 21.3136 23.1828 21.0136 23.1828Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8551 42.2044H40.92V21.5452H42.0068V41.0866H42.8551C43.9902 41.0866 44.9135 40.137 44.9135 38.9694V16.235C44.9135 15.0674 43.9902 14.1178 42.8551 14.1178H19.1384C18.1255 14.1178 17.25 14.8936 17.1022 15.9226C17.0876 16.026 17.08 16.131 17.08 16.235V17.3551H15.9932V16.235C15.9932 16.0768 16.0046 15.917 16.0274 15.7594C16.2529 14.186 17.5908 13 19.1384 13H42.8551C44.5896 13 46.0003 14.4509 46.0003 16.235V38.9694C46.0003 40.7535 44.5896 42.2044 42.8551 42.2044Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9417 21.5452H25.8549V20.8399C25.8549 20.4844 25.574 20.1955 25.2284 20.1955H16.5361V19.0776H25.2284C26.1733 19.0776 26.9417 19.8679 26.9417 20.8399V21.5452Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4167 18.7461H41.3662V19.8639H45.4167V18.7461Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9346 17.355H29.8478V17.0437C29.8478 16.6888 29.5669 16.3998 29.2218 16.3998H16.5361V15.282H29.2218C30.1662 15.282 30.9346 16.0723 30.9346 17.0437V17.355Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3151 20.9863H41.4629V22.1042H45.3151V20.9863Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1081 20.7555H30.8461C30.5462 20.7555 30.3027 20.5051 30.3027 20.1966C30.3027 19.8881 30.5462 19.6377 30.8461 19.6377H31.1081C31.408 19.6377 31.6515 19.8881 31.6515 20.1966C31.6515 20.5051 31.408 20.7555 31.1081 20.7555Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0436 20.7555H32.7817C32.4817 20.7555 32.2383 20.5051 32.2383 20.1966C32.2383 19.8881 32.4817 19.6377 32.7817 19.6377H33.0436C33.3436 19.6377 33.587 19.8881 33.587 20.1966C33.587 20.5051 33.3436 20.7555 33.0436 20.7555Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9801 20.7555H34.7182C34.4182 20.7555 34.1748 20.5051 34.1748 20.1966C34.1748 19.8881 34.4182 19.6377 34.7182 19.6377H34.9801C35.2801 19.6377 35.5235 19.8881 35.5235 20.1966C35.5235 20.5051 35.2801 20.7555 34.9801 20.7555Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2165 16.2133H37.9545C37.6546 16.2133 37.4111 15.9629 37.4111 15.6544C37.4111 15.3459 37.6546 15.0955 37.9545 15.0955H38.2165C38.5164 15.0955 38.7599 15.3459 38.7599 15.6544C38.7599 15.9629 38.5164 16.2133 38.2165 16.2133Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.152 16.2133H39.8901C39.5901 16.2133 39.3467 15.9629 39.3467 15.6544C39.3467 15.3459 39.5901 15.0955 39.8901 15.0955H40.152C40.452 15.0955 40.6954 15.3459 40.6954 15.6544C40.6954 15.9629 40.452 16.2133 40.152 16.2133Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0885 16.2133H41.8266C41.5266 16.2133 41.2832 15.9629 41.2832 15.6544C41.2832 15.3459 41.5266 15.0955 41.8266 15.0955H42.0885C42.3885 15.0955 42.6319 15.3459 42.6319 15.6544C42.6319 15.9629 42.3885 16.2133 42.0885 16.2133Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1221_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 33,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPartyIcon);
export default __webpack_public_path__ + "static/media/third_party_icon.dea2873516ad3a5cccc59a58d7f95824.svg";
export { ForwardRef as ReactComponent };